import React, { ReactNode } from 'react';

import * as Styles from './DropdownMenuStyles';

interface Props {
  open: boolean;
  children: ReactNode;
}

const DropdownMenu: React.FC<Props> = ({ open, children }: Props) => {
  if (!open) return <></>;

  return (
    <Styles.Container id="dropdown-container" data-testid="dropdown-container">
      {children}
    </Styles.Container>
  );
};

export default DropdownMenu;
